import { render, staticRenderFns } from "./RandomTest.vue?vue&type=template&id=0f8b9b16&"
import script from "./RandomTest.vue?vue&type=script&lang=js&"
export * from "./RandomTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports